
function setAccessToken(token) {
  window.sessionStorage.setItem('accessToken', JSON.stringify(token));
}

function setResetToken(token) {
  window.sessionStorage.setItem('resetToken', JSON.stringify(token));
}

function getAccessToken() {
  const token = window.sessionStorage.getItem('accessToken');

  return token ? JSON.parse(token) : undefined;
}

function getResetToken() {
  const resetToken = window.sessionStorage.getItem('resetToken');

  return resetToken ? JSON.parse(resetToken) : undefined;
}

function removeAccessToken() {
  window.sessionStorage.removeItem('accessToken');
}

function removeResetToken() {
  window.sessionStorage.removeItem('resetToken');
}

function updateUser(user) {
  const token = getAccessToken();
  token.user = user;
  setAccessToken(token);
}

export default {
  setAccessToken,
  getAccessToken,
  removeAccessToken,
  updateUser,
  setResetToken,
  getResetToken,
  removeResetToken,
};



// WEBPACK FOOTER //
// ./src/Session.js